export const SliceNames = Object.freeze({
    FAQ: 'faq',
    FEATURED_ICONS: 'featured_icons',
    INFO_BANNER: 'info_banner',
    TEXT_ME_THE_APP: 'text_me_the_app',
});
